<template>
    <div class="card-mask" style="padding: 15px;">
        <div class="card" style="flex: 1 auto;">
            <div v-if="isEmpty" class="content">
                <div class="row">
                    <template v-for="(s) in itemEx.qs.txtArr">
                        <text2 :interval="s[1]*100" :txt="s[0]"/>
                    </template>
                </div>
                <div class="row">
                    <template v-for="(s) in itemEx.xj.txtArr">
                        <text2 :interval="s[1]*100" :txt="s[0]"/>
                    </template>
                </div>
                <div class="row" style="position: relative;overflow: auto;pointer-events: auto;">
                    <div class="qw">
                        <div class="qw-item" style="text-align: left;" v-for="obj in itemEx.qw">
                            <template v-for="(s) in obj.txtArr">
                                <text2 :interval="s[1]*100" :txt="s[0]"/>
                            </template>
                        </div>
                    </div>
                    <div v-if="!showQw" class="dg">
                        {{item['典故']}}
                    </div>
                </div>
                <div class="row qy">
                    <!--<template v-if="!showQy">-->
                    <!--<div style="display: flex;justify-content: center;align-items: center;flex: 1 1 auto;pointer-events: all;"-->
                    <!--@click="onclick">-->
                    <!--解签-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--<template v-if="showQy" v-for="(s,i) in itemEx.qy.txtArr">-->
                    <!--&lt;!&ndash;<text2 :interval="s[1]*100" :txt="s[0]"/>&ndash;&gt;-->
                    <!--<text3 :interval="i*500" :txt="s[0]"/>-->
                    <!--</template>-->
                    <template v-if="!showQy" v-for="(s,i) in itemEx.qy.txtArr">
                        <text3 :interval="0" :txt="s[0]"/>
                    </template>
                    <template v-if="showQy" v-for="(s,i) in itemEx.qy.txtArr">
                        <text3 :interval="i*500" :txt="s[0]"/>
                    </template>
                    <div v-if="!showQy" class="qy-mask"></div>
                </div>
                <div class="row" style="justify-content: space-around;">
                    <my-button style="pointer-events: all;" @click="onclick">解签</my-button>
                    <my-button style="pointer-events: all;" @click="onclick2">{{showQw?'典故':'签文'}}</my-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'
    import { numberStr, } from '@/assets/data1'
    import Text2 from '@/components/Text/text2'
    import Text3 from '@/components/Text/text3'
    import MyButton from '@/components/Button'

    export default {
        name: 'Card',
        components: {
            Text2,
            Text3,
            MyButton
        },
        props: {
            item: { type: Object, default: () => {} }
        },
        // watch: {
        //     'item': {
        //         handler: (newValue) => {
        //             console.log('123', newValue)
        //         },
        //         deep:true
        //     }
        // },
        setup: (props, context) => {
            const state = reactive({
                props,
                showQy: false,
                showQw: true,
                itemEx: {},
                onclick: () => {
                    state.showQy = true
                },
                onclick2: () => {
                    state.showQw = !state.showQw
                }
            })

            const isEmpty = computed(() => {
                return props.item['签数'] ? true : false
            })

            const getQs = computed(() => {
                return numberStr[props.item['签数'] - 1]
            })

            const getQw = computed(() => {
                // console.log(props.item['签文'])
                let arr = []
                props.item['签文']?.forEach(v => {
                    v.split('，')?.map(v2 => {
                        arr.push(v2.replace('。', ''))
                    })
                })

                return arr
            })

            const itemEx = {
                qs: {
                    txtArr: [],
                    txt: `${getQs.value} ${props.item['签名']}`
                },
                xj: {
                    txtArr: [],
                    txt: props.item['吉凶']
                },
                qw: [],
                qy: {
                    txtArr: [],
                    txt: props.item['签解'] + props.item['签意']
                }
            }

            if (isEmpty.value) {
                getQw.value?.map(v => {
                    itemEx.qw.push({
                        txtArr: [],
                        txt: v
                    })
                })
                // console.log('itemEx', itemEx)
                let index = 10
                itemEx.qs.txt.split('').map(v => {
                    itemEx.qs.txtArr.push([v, index++])
                })
                itemEx.xj.txt.split('').map(v => {
                    itemEx.xj.txtArr.push([v, index++])
                })
                itemEx.qw.map(v1 => {
                    v1.txt.split('').map(v => {
                        v1.txtArr.push([v, index++])
                    })
                })
                itemEx.qy.txt.split('').map(v => {
                    itemEx.qy.txtArr.push([v, index++])
                })
            }

            state.itemEx = itemEx
            return {
                isEmpty,
                getQs,
                getQw,
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .card-mask {
        position: absolute;
        left: 0;
        top: 0;
        bottom: -80px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        pointer-events: none;
    }

    .card {
        /*display: flex;*/
        /*background: rgba(255, 255, 255, 0.5);*/
        background-image: linear-gradient(to right bottom, transparent 50%, rgba(0, 0, 0, 0.1));
        backdrop-filter: blur(10px);
        box-shadow: 5px 5px 5px #888;
        max-width: 300px;

        .content {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
        }

        .content > .row:not(:first-child) {
            border-top: 0px;
        }

        .row {
            display: flex;
            justify-content: center;
            padding: 8px;
            text-align: center;
            border: 1px solid black;
        }

        .qs {
            width: 50%;
            text-align: right;
        }
        .qm {
            text-align: left;
        }
        .qw {
            writing-mode: vertical-lr;
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;

            .qw-item {
                margin: 4px 16px;
            }
        }
        .dg {
            position: absolute;
            padding: 8px;
            text-align: left;
            background: #fff;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }
        .qy {
            text-align: left;
            flex-wrap: wrap;
            justify-content: start;
            position: relative;
        }

        .qy-mask {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            /*backdrop-filter: blur(10px);*/
            background-color: #fff;
            background-image:url("~@/assets/jiao.png");
            background-size: 30px 30px;
            background-repeat: repeat;
        }

        animation-name: anima-card;
        animation-duration: 1s;
        animation-timing-function: linear;
    }

    @keyframes anima-card {
        0% {
            transform: scale(0, 1);
        }
        100% {
            transform: scale(1, 1);
        }
    }
</style>